import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取提单号列表
export function getInsureList(params) {
  return request({
    url: URL.seaExport.getInsureList,
    method: 'get',
    params
  })
}

// 获取提单记录
export function getInsureRecord(data) {
  return request({
    url: URL.seaExport.getInsureRecord,
    method: 'post',
    data
  })
}

// 校验是否允许货运险投保
export function checkFreightInsurance(data) {
  return request({
    url: URL.seaExport.checkFreightInsurance,
    method: 'post',
    data
  })
}
// 校验是否泓明是否业务已经投保
export function checkHmFreightInsurance(data) {
  return request({
    url: URL.seaExport.checkHmFreightInsurance,
    method: 'post',
    data
  })
}
// 货运险投保
export function freightInsurance(data) {
  return request({
    url: URL.seaExport.freightInsurance,
    method: 'post',
    data
  })
}

export function getClaimJumpUrl(data) {
  return request({
    url: URL.seaExport.getClaimJumpUrl,
    method: 'post',
    data
  })
}

// 责任险询价
export function liabilityInsurance(data) {
  return request({
    url: URL.seaExport.liabilityInsurance,
    method: 'post',
    data
  })
}

// 高级查询
export function insureAdvacedQuery(data) {
  return request({
    url: URL.seaExport.insureAdvacedQuery,
    method: 'post',
    data
  })
}

// 移除投保记录
export function removeInsureRecord(data) {
  return request({
    url: URL.seaExport.removeInsureRecord,
    method: 'post',
    data
  })
}
// 检查投保记录
export function checkInsureDeleteFunc(data) {
  return request({
    url: URL.seaExport.checkInsureDeleteUrl,
    method: 'post',
    data
  })
}
// 获取跳转链接
export function getJumpUrl(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.getJumpUrl,
    method: 'post',
    data
  })
}
// 记录保单下载操作
export function recordDownPolicy(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.recordDownPolicy,
    method: 'post',
    data
  })
}
// 询价文件上传
export function uploadInquiryFile(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.uploadInquiryFile,
    method: 'post',
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    data
  })
}
// 获取当前分公司下该用户是否存在未提交的询价单
export function getLiabilityUnSubmit(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.getLiabilityUnSubmit,
    method: 'post',
    data
  })
}

